import { State } from "@/store/modules/speedNetworking";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";

const setWaitingMeeting = (state: State, payload: boolean) => {
  state.waitingMeeting = payload;
};

const setUserInMeeting = (state: State, payload: SpaceUserInterface) => {
  state.userInMeeting = payload;
};
const setEnterInNetworking = (state: State, payload: boolean) => {
  state.enterInNetworking = payload;
};

const setShowEnterModal = (state: State, payload: boolean) => {
  state.showEnterModal = payload;
};

const setWaitingTime = (state: State, payload) => {
  state.waitingTime = payload;
};

const setMeetingTime = (state: State, payload) => {
  state.meetingTime = payload;
};

export default {
  setWaitingMeeting,
  setUserInMeeting,
  setEnterInNetworking,
  setShowEnterModal,
  setWaitingTime,
  setMeetingTime,
};
